export const DURATION_UNIT_FALLBACK = "days";

export const durationUnitMap = {
  minutes: "minute",
  hours: "hour",
  days: "day",
  weeks: "week",
  months: "month",
  years: "year",
};

export const parseCombinedDuration = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return { value: "", unit: "" };
  const match = raw.match(/^(\d+)\s+([a-zA-Z]+)$/);
  if (!match) return { value: "", unit: "" };
  return {
    value: match[1],
    unit: String(match[2]).toLowerCase(),
  };
};

export const buildCombinedDuration = (value, unit) => {
  if (value === null || value === undefined || value === "") return "";
  const cleanValue = String(value).replace(/\D/g, "");
  const cleanUnit = String(unit || "").trim().toLowerCase();
  if (!cleanValue || !cleanUnit) return "";
  return `${cleanValue} ${cleanUnit}`;
};

export const normalizeLegacyDuration = (
  combinedValue,
  legacyValue,
  legacyUnit,
  fallbackUnit = DURATION_UNIT_FALLBACK
) => {
  const combined = String(combinedValue || "").trim();
  if (combined && parseCombinedDuration(combined).value) return combined;
  return buildCombinedDuration(
    String(legacyValue || "").replace(/\D/g, ""),
    legacyUnit || fallbackUnit
  );
};

export const getDurationDropdownOptions = (numericInput, durationType = []) => {
  const numberPart = String(numericInput || "").replace(/\D/g, "");
  if (!numberPart) return [];
  return durationType.map((type) => `${numberPart} ${type.value}`);
};
